/**
 * @Description FasatColumnOrder ClassNames File
 * @FileName classNames.js
 * @Author ABHISEK KUNDU-kundabh
 * @CreatedOn 22 March, 2021 02:59:30
 * @IssueID 673
 */

/**
 * Generates a className string from an object where keys are class names
 * and values determine if the class should be included (truthy = include).
 *
 * @param {Object} classes - Object with class names as keys and boolean values
 * @returns {string} Space-separated class names string
 *
 * @example
 * classNames({ 'rdl-move': true, 'rdl-move-top': true, 'disabled': false })
 * // Returns: 'rdl-move rdl-move-top'
 */
const classNames = (classes) => {
  if (!classes || typeof classes !== 'object') {
    return '';
  }

  return Object.entries(classes)
    .filter(([, value]) => value)
    .map(([key]) => key)
    .join(' ');
};

export default classNames;
